import { Link, Button, Box, Stack, Typography } from "fashion/fabrics";
import { TouchAppIcon, TravelExploreIcon } from "fashion/icons";
import CodexUserTargetGrid from "nodes/codex/CodexUserTargetGrid";
import { STATIC_ROUTES } from "nodes/codex/CodexRoutes";

const BlogCardConceptPage = () => (
  <Stack gap={3}>
    <Typography variant="h3" textAlign="center">
      The{" "}
      <Box color="secondary.main" component="span" display="inline">
        Card
      </Box>{" "}
      concept
    </Typography>
    <Typography color="text.secondary" textAlign="center">
      Eliminates the complexity of creating{" "}
      <Box color="secondary.main" component="span" display="inline">
        navigable interfaces
      </Box>{" "}
      by creating cards chained with up to 24 links each.
    </Typography>
    <Box margin="auto">
      <Button
        component={Link}
        href={STATIC_ROUTES.ROOT}
        size="large"
        variant="outlined"
        color="secondary"
        startIcon={<TravelExploreIcon />}
        endIcon={<TouchAppIcon />}
      >
        Concept Page
      </Button>
      <Typography
        mt={0.5}
        color="text.disabled"
        textAlign="center"
        variant="body2"
      >
        Read more about the card concept
      </Typography>
    </Box>
    <CodexUserTargetGrid />
  </Stack>
);

export default BlogCardConceptPage;
